/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_GoogleInputs */

const en_us2_onboarding_how_heard_google = /** @type {(inputs: Onboarding_How_Heard_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const pt_br2_onboarding_how_heard_google = /** @type {(inputs: Onboarding_How_Heard_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const es_419_onboarding_how_heard_google = /** @type {(inputs: Onboarding_How_Heard_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const pt_pt2_onboarding_how_heard_google = /** @type {(inputs: Onboarding_How_Heard_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const fr_fr2_onboarding_how_heard_google = /** @type {(inputs: Onboarding_How_Heard_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const de_de2_onboarding_how_heard_google = /** @type {(inputs: Onboarding_How_Heard_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

const it_it2_onboarding_how_heard_google = /** @type {(inputs: Onboarding_How_Heard_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

/**
* | output |
* | --- |
* | "Google" |
*
* @param {Onboarding_How_Heard_GoogleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_google = /** @type {((inputs?: Onboarding_How_Heard_GoogleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_GoogleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_google(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_google(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_google(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_google(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_google(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_google(inputs)
	return en_us2_onboarding_how_heard_google(inputs)
});
export { onboarding_how_heard_google as "onboarding.how_heard.google" }